import { RichText, Text } from '@sitecore-jss/sitecore-jss-nextjs';
import { ContentBlockWithGradientProps } from './ContentBlockWithGradient.types';
import {
  StContentBox,
  StContentWrapper,
  StGradientContainer,
  StHeading,
} from './ContentBlockWithGradient.styles';

const ContentBlockWithGradient = (props: ContentBlockWithGradientProps): JSX.Element => {
  if (!props?.fields) return <></>;

  const { heading, content, gradient } = props.fields;

  if (!heading?.value && !content?.value) return <></>;

  return (
    <StGradientContainer
      id="content-block-with-gradient"
      className="ui-content-block-with-gradient"
      sx={{ background: gradient?.value || undefined }}
    >
      <StContentWrapper id="container">
        {heading?.value && (
          <StHeading variant="h1" className="ui-content-block-with-gradient-heading">
            <Text field={heading} />
          </StHeading>
        )}
        {content?.value && (
          <StContentBox>
            <RichText field={content} />
          </StContentBox>
        )}
      </StContentWrapper>
    </StGradientContainer>
  );
};

export default ContentBlockWithGradient;
